export const PAGINATION_LECTURES_LIMIT = 8;
